const validateCurrencyCodes = (currencies: Array<string>) => {
  if (typeof Intl.supportedValuesOf !== 'function') {
    // Environment doesn't support Intl.supportedValuesOf; skip client-side validation.
    return '';
  }

  const validCurrencies = new Set(Intl.supportedValuesOf('currency'));
  const invalid = currencies.filter((code) => !validCurrencies.has(code.toUpperCase()));
  if (invalid.length > 0) {
    return `Invalid currency code${invalid.length > 1 ? 's' : ''}: ${invalid.join(', ')}`;
  }
  return '';
};

export default validateCurrencyCodes;
